// extracted by mini-css-extract-plugin
var _1 = "ClientsShopSelect_filter__tC3pw";
var _2 = "ClientsShopSelect_filtersContainer__7PFMJ";
export { _1 as "filter", _2 as "filtersContainer" }
